import type { ApiDataResponse, ApiResponse } from '@/utils/api';

type Response = ApiResponse | ApiDataResponse<any>;

/**
 * 檢查 Api Response 是否成功
 */
export default function isApiSuccess(response: Response | Response[]): boolean {
  return Array.isArray(response)
    ? response.every(({ data }) => data.isSuccess)
    : response.data.isSuccess;
}
